import { mount } from "@vue/test-utils";
import ModalComponent from "@/components/core/ModalComponent";

describe("ModalComponent test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(ModalComponent);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component ModalComponent", () => {
    expect(wrapper).toBeDefined();
  });
});
